<template>
  <div>
    <el-form ref="form" :model="form" label-width="60px">
      <el-form-item label="知识点" style="width: 600px">
        <el-select
          v-model="form.knows"
          placeholder="-请选择知识点-"
          @change="getKnows"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.knowledgeName"
            :value="item.id"
          >
            {{ item.knowledgeName }}
          </el-option>
          <!-- <div
            @click="knowLegGetList"
            v-show="more"
            style="
              text-align: center;
              font-size: 12px;
              color: #ccc;
              padding: 5px 0;
              cursor: pointer;
            "
          >
            点击更多
          </div> -->
        </el-select>
      </el-form-item>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      row-key="id"
      @selection-change="handleSelectionChange"
      style="width: 100%"
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="55"
      ></el-table-column>
      <el-table-column prop="title" label="课件名称"> </el-table-column>
      <el-table-column prop="typeName" label="课件类型"> </el-table-column>
      <el-table-column prop="knowledgeName" label="知识点名称">
      </el-table-column>
      <el-table-column prop="type" label="类型">
        <template #default="scope">
          <span v-if="scope.row.type == '1'">视频</span>
          <span v-if="scope.row.type == '2'">音频</span>
          <span v-if="scope.row.type == '3'">文本</span>
          <span v-if="scope.row.type == '4'">文档</span>
          <span v-if="scope.row.type == '5'">音视频链接</span>
        </template>
      </el-table-column>

      <el-table-column prop="uname" label="上传人"> </el-table-column>
      <el-table-column prop="ctime" label="上传时间" :formatter="formatDate">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import * as api from '@/api/courseStructure/courseStructure'
export default {
  props: ['courseWareId', 'institutionId', 'zyVideoSectionId', 'videoDataId'],
  data() {
    return {
      form: {
        knows: '',
      },
      oldKnowleg: '',
      knowledgeId: '',
      type: '',
      options: [],
      more: true,
      page: 0,
      tableData: [],
      pageObj: {
        page: 1,
        pageSize: 10,
      },
      total: 0,
      multipleSelection: [],
      ifCheck: false,
      num: 0,
    }
  },
  created() {
    this.knowLegGetList()
    if (this.zyVideoSectionId !== '') {
      this.ifCheck = true
      this.getCoursewareDetail()
    } else {
      this.getTableList()
    }
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
  methods: {
    // 时间戳转日期
    formatDate(row, column, cellValue, index) {
      if (cellValue == null || cellValue == '') return ''
      let date = new Date(parseInt(cellValue) * 1000) //时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-'
      let M =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1) + '-'
          : date.getMonth() + 1 + '-'
      let D =
        date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
      let h =
        date.getHours() < 10
          ? '0' + date.getHours() + ':'
          : date.getHours() + ':'
      let m =
        date.getMinutes() < 10
          ? '0' + date.getMinutes() + ':'
          : date.getMinutes() + ':'
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    knowLegGetList() {
      // this.page++
      api
        .knowLegGetList({
          page: 1,
          // pageSize: '10',
          courseWareId: this.courseWareId,
        })
        .then(({ data }) => {
          data = data.data
          // if (data.total < 10) {
          //   this.more = false
          // }
          // if (this.page * 10 > data.total) {
          //   this.more = false
          // }
          this.options = data.list.map((item) => {
            return { knowledgeName: item.knowledgeName, id: item.id }
          })
        })
    },
    getTableList() {
      const { page, pageSize } = this.pageObj
      let knowledgeId = this.form.knows
      if (this.ifCheck) {
        knowledgeId = this.knowledgeId
      }
      api
        .getList2({
          page,
          pageSize,
          courseWareId: this.courseWareId,
          knowledgeId,
          type: this.type,
          status: '1',
          wareStatus: '1',
          uid: 1,
          institutionId: this.institutionId,
          zyVideoSectionId: this.zyVideoSectionId,
        })
        .then(({ data }) => {
          data = data.data
          this.tableData = data.list
          this.total = data.total
          if (this.num < 1) {
            const index = this.tableData.findIndex(
              (item) => item.checked === '1'
            )
            if (index > -1) {
              this.$refs.multipleTable.toggleRowSelection(
                this.tableData[index],
                true
              )
            }
          }
          this.num++
        })
    },
    getKnows(value) {
      this.form.knows = value
      this.knowledgeId = value
      this.pageObj.page = 1
      this.$refs.multipleTable.clearSelection()
      this.getTableList()
    },
    //获取课件信息
    getCoursewareDetail() {
      api
        .getDetail({ id: this.videoDataId, courseWareId: this.courseWareId })
        .then(({ data }) => {
          data = data.data
          // this.form.name = data.title
          this.form.knows = data.knowledgeName //由于分页请求回来的数据中id无法匹配到对应的名字
          this.knowledgeId = data.knowledgeId //编辑时利用这个id请求表格
          // this.type = data.type
          this.getTableList()
        })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getTableList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getTableList()
    },
    save() {
      const selectedList = this.$refs.multipleTable.selection
      if (selectedList.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请先选择需要操作的数据',
        })
      } else if (selectedList.length > 1) {
        return this.$message({ type: 'warning', message: '最多可选一个课件' })
      } else {
        this.$parent.$parent.submitForm()
      }
    },
    appendChild(zyVideoSectionId) {
      const selectedList = this.$refs.multipleTable.selection
      let formdata = new FormData()
      formdata.append('zyVideoSectionId', zyVideoSectionId)
      formdata.append('id', selectedList[0].id)
      api.updateVideoData(formdata).then(({ data }) => {
        if (data.code == 100000) {
          this.$emit('endSave')
          this.$message({ type: 'success', message: data.msg })
        } else {
          this.$message({ type: 'error', message: data.msg })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.empty_knows {
  padding: 10px 0;
  margin: 0;
  text-align: center;
  color: #999;
  font-size: 14px;
}
</style>
